import fetch from '@/api/fetch'

export default {
  /**
   * 获取底部的温馨提示文案，positionKey 为入参
   * [
   *   {
   *     "positionKey": "send_start_tips",
   *     "positionName": "寄修_引导页_温馨提示"
   *   },
   *   {
   *     "positionKey": "send_success_tips",
   *     "positionName": "寄修_成功页_温馨提示"
   *   },
   *   {
   *     "positionKey": "home_start_tips",
   *     "positionName": "上门_引导页_温馨提示"
   *   },
   *   {
   *     "positionKey": "home_success_tips",
   *     "positionName": "上门_成功页_温馨提示"
   *   },
   *   {
   *     "positionKey": "run_start_tips",
   *     "positionName": "同城_引导页_温馨提示"
   *   },
   *   {
   *     "positionKey": "run_success_tips",
   *     "positionName": "同城_成功页_温馨提示"
   *   },
   *   {
   *     "positionKey": "store_start_tips",
   *     "positionName": "到店_引导页_温馨提示"
   *   },
   *   {
   *     "positionKey": "store_success_tips",
   *     "positionName": "到店_成功页_温馨提示"
   *   },
   *   {
   *     "positionKey": "cost_tips",
   *     "positionName": "费用清单_温馨提示"
   *   }
   * ]
   */

  getResource(params) {
    return fetch({
      url: '/commonservice/imgTextResource',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
      },
      method: 'post',
      data: params
    })
  }
}
